var __default__ = {root:'m_ddec01c0',icon:'m_dde7bd57',cite:'m_dde51a35'};
export default __default__;